export default __webpack_public_path__ + "static/media/Beginsituatieanalyse adhv de SDG’s.fc355d9e.zip";